// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-module--title--P1QBZ","shadow":"styles-module--shadow--2ayBT"};